import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { Button } from '../../components/Button';
import FormField from '../../components/ui/FormField';

const meetingTypes = [
    { value: 'BOARD_MEETING', label: 'Board Meeting' },
    { value: 'GENERAL_MEETING', label: 'General Meeting' }
];

const AccountMeeting = ({ meetings, onMeetingsChange }) => {
    const handleMeetingChange = (index, name, value) => {
        let formattedValue = value;

        if ((name === "meetingDate" || name === "noticeIssueDate") && value) {
            formattedValue = `${value}T00:00:00`;
        }

        const updatedMeetings = [...meetings];
        updatedMeetings[index] = {
            ...updatedMeetings[index],
            [name]: formattedValue
        };
        onMeetingsChange(updatedMeetings);
    };

    const addMeeting = () => {
        onMeetingsChange([
            ...meetings,
            {
                meetingDate: '',
                presentMembers: '',
                noticeIssueDate: '',
                agenda: '',
                meetingType: ''
            }
        ]);
    };

    const removeMeeting = (index) => {
        const updatedMeetings = [...meetings];
        updatedMeetings.splice(index, 1);
        onMeetingsChange(updatedMeetings);
    };

    return (
        <div>
            <div className="flex justify-between items-center border-b pb-2 mb-2">
                <h2 className="text-lg font-medium text-gray-800">Meetings</h2>
                <Button label="Add Meeting" onClick={addMeeting} />
            </div>

            <div className="space-y-6">
                {meetings.map((meeting, index) => (
                    <div key={index} className="border rounded-lg p-4 relative">
                        <button
                            onClick={() => removeMeeting(index)}
                            className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                        >
                            <FiTrash2 />
                        </button>

                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <FormField
                                label="Meeting Date"
                                type="date"
                                value={meeting.meetingDate?.split("T")[0] || ""}
                                onChange={(value) => handleMeetingChange(index, 'meetingDate', value)}
                            />

                            <FormField
                                label="Meeting Type"
                                type="dropdown"
                                value={meeting.meetingType}
                                onChange={(value) => handleMeetingChange(index, 'meetingType', value)}
                                options={meetingTypes}
                            />

                            <FormField
                                label="Notice Issue Date"
                                type="date"
                                value={meeting.noticeIssueDate?.split("T")[0] || ""}
                                onChange={(value) => handleMeetingChange(index, 'noticeIssueDate', value)}
                            />

                            <FormField
                                label="Present Members"
                                type="text"
                                value={meeting.presentMembers}
                                onChange={(value) => handleMeetingChange(index, 'presentMembers', value)}
                                placeholder="John, Alice, Bob"
                            />
                        </div>

                        <div className="md:col-span-2 mt-3">
                            <FormField
                                label="Agenda"
                                type="description"
                                value={meeting.agenda}
                                onChange={(value) => handleMeetingChange(index, 'agenda', value)}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccountMeeting;
